import React , {useEffect, useState , useRef } from 'react';
import { useDispatch , useSelector} from 'react-redux';

import {   modifyDisplaymodal} from '../../state/redux';


import { axios_contrats_search } from '../../axios/axios_contrats';

import TabloContrats from './TabloContrats';

import './GestionRecherche.scss';


function RechercheContrats(){
  const dispatch = useDispatch();

  const [value, setValue ]= useState('');
  const [resultsearch , setResultsearch] = useState([]);
  const inputReference = useRef(null);
  
  useEffect(() => { inputReference.current.focus();}, [])

  const recherche =async (value)=>{
    const response = await axios_contrats_search(value?.trim()) ; 
   setResultsearch(response.data) ; 
  }


  const handleChange =async (e)=>{ setValue(e.target.value);
    if(e.target.value.length===0 ){  setResultsearch([])}
  }

  const searchContrats = async (e) => {
     e.key === 'Enter' && await recherche(e.target.value?.trim())
  }

    useEffect(()=>{
        if(value.length<4){return }
        const getData = setTimeout(() => {recherche(value?.trim());}, 2000);  
        return () => clearTimeout(getData)
  },[value]);


    return(<div className='containergray' >
                <div className='gestionsearch_content' >
                    <div className='search_content_top'> 
                        <div> 
                          <input ref={inputReference} 
                                  id="inputsearch"     
                                  type="text"  
                                  value={value} 
                                  onChange={handleChange} 
                                  onKeyDown={searchContrats}   />  
                          </div>
                        <div className='search_close' onClick={()=>{ dispatch(modifyDisplaymodal(null))   }}   >  </div>
                    </div>
                    <div className='gestiontablesearch_container'  >
                      {resultsearch.length >0 && <TabloContrats datas={resultsearch} />}
                    </div>
                </div>
            </div> )
}

export default RechercheContrats
